// locales
import { useLocales } from '../../../locales';
import { PATH_PAGE, PATH_AUTH, PATH_AGROLAB_PAGE } from '../../../routes/paths';
import Iconify from '../../../components/iconify';

export function useNavConfig() {
  const { translate } = useLocales();

  const navConfig = [
    {
      title: translate('NAV.HOME'),
      icon: <Iconify icon="iconamoon:home-duotone" />,
      path: '/',
    },
    {
      title: translate('NAV.GO_TO_MARKET'),
      icon: <Iconify icon="ant-design:question-circle-twotone" />,
      path: PATH_PAGE.marketHome,
    },
    {
      title: translate('NAV.WHO_ARE_WE'),
      icon: <Iconify icon="ant-design:question-circle-twotone" />,
      path: PATH_PAGE.about,
    },
    { title: translate('NAV.MEGA_MENU.CHILDREN_2.PAGE_1'), path: PATH_AUTH.login, },
    {
      title: translate('NAV.MEGA_MENU.TITLE'),
      path: '/pages',
      icon: <Iconify icon="icon-park-twotone:more-two" />,
      children: [
        {
          subheader: translate('NAV.MEGA_MENU.CHILDREN_1.SUBHEADER'),
          items: [
            { title: translate('NAV.MEGA_MENU.CHILDREN_1.PAGE_1'), path: PATH_AGROLAB_PAGE },
            { title: translate('NAV.MEGA_MENU.CHILDREN_1.PAGE_2'), path: PATH_PAGE.benefit },
            { title: translate('NAV.MEGA_MENU.CHILDREN_1.PAGE_3'), path: PATH_PAGE.funcionality },
            { title: translate('NAV.MEGA_MENU.CHILDREN_1.PAGE_7'), path: PATH_PAGE.agroLabStamp },
            { title: translate('NAV.MEGA_MENU.CHILDREN_1.PAGE_8'), path: PATH_PAGE.contact },
          ],
        },
        {
          subheader: translate('NAV.MEGA_MENU.CHILDREN_2.SUBHEADER'),
          items: [
            { title: translate('NAV.MEGA_MENU.CHILDREN_2.PAGE_1'), path: PATH_AUTH.login, },
            { title: translate('NAV.MEGA_MENU.CHILDREN_2.PAGE_2'), path: PATH_AUTH.register },
            { title: translate('NAV.MEGA_MENU.CHILDREN_2.PAGE_3'), path: PATH_AUTH.resetPassword },
            { title: translate('NAV.MEGA_MENU.CHILDREN_2.PAGE_4'), path: PATH_AUTH.verify },
          ],
        },
      ],
    },
  ];

  return navConfig;
}